import { render } from "./SampleStockForm.vue?vue&type=template&id=4dd6c256&scoped=true"
import script from "./SampleStockForm.vue?vue&type=script&lang=ts"
export * from "./SampleStockForm.vue?vue&type=script&lang=ts"

import "./SampleStockForm.vue?vue&type=style&index=0&id=4dd6c256&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4dd6c256"

export default script